import { QueryTerm } from '../classes/query-term';

export class Queries {

  /**
   * Should use with Array.find
   * return true if element found either return false
   * query by property and value
   *
   * @param object
   * @param {string} property
   * @param {string | number | boolean|QueryTerm[]} compareValue
   * @return {boolean}
   */
  public static findByProperty(object: any, property: string, compareValue: string | number | boolean | QueryTerm[]): boolean {
    if (compareValue instanceof Array && compareValue[0] instanceof QueryTerm) {
      return Queries.findByTerms(object[property], compareValue);
    }
    else if (object instanceof Array) {
      return object.find(element => Queries.findByProperty(element, property, compareValue));
    }
    else {
      return (object[property] === compareValue);
 }
  }

  /**
   * Should use with Array.find
   * return true if element found either return false
   * query by multiple terms
   *
   *
   * @param object
   * @param {QueryTerm[]} terms
   * @return {boolean}
   */
  public static findByTerms(object: any, terms: QueryTerm[]): boolean {
    let check = true;
    for (const term of terms) {
      check = check && Queries.findByProperty(object, term.searchKey, term.searchValue);
    }
    return check;

  }

}

